import { useState, useMemo } from 'react';
import { useDealsStore } from '../../store/deals';
import { useUIStore } from '../../store/ui';
import { relativeTime } from '../../lib/utils';

export function DealIndex() {
  const deals = useDealsStore(s => s.deals);
  const setShow = useUIStore(s => s.setShowDealIndex);
  const openDeal = useUIStore(s => s.openDeal);

  const [showClosed, setShowClosed] = useState(false);
  const [query, setQuery] = useState('');

  const closedCount = useMemo(() => deals.filter(d => !!d.closedOutcome).length, [deals]);

  const visible = useMemo(() => {
    let list = deals;
    if (!showClosed) list = list.filter(d => !d.closedOutcome);
    if (query.trim()) {
      const q = query.toLowerCase();
      list = list.filter(d =>
        d.ownerName.toLowerCase().includes(q) ||
        d.trs.toLowerCase().includes(q) ||
        d.county.toLowerCase().includes(q) ||
        (d.operator && d.operator.toLowerCase().includes(q))
      );
    }
    return list;
  }, [deals, showClosed, query]);

  return (
    <>
      <div className="deal-index-backdrop" onClick={() => setShow(false)}>
        <div className="deal-index" onClick={e => e.stopPropagation()}>
          <div className="deal-index-head">
            <div className="deal-index-title">All <em style={{ color: 'var(--accent)', fontStyle: 'italic' }}>deals</em></div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn-ghost" style={{ padding: '4px 10px', fontSize: 11 }} onClick={() => setShow(false)}>Close</button>
            </div>
          </div>

          <div className="deal-index-controls">
            <input
              className="deal-index-search"
              type="text"
              placeholder="Search owner · TRS · county · operator…"
              value={query}
              onChange={e => setQuery(e.target.value)}
              autoFocus
            />
            {closedCount > 0 && (
              <label className="deal-index-toggle">
                <input
                  type="checkbox"
                  checked={showClosed}
                  onChange={e => setShowClosed(e.target.checked)}
                />
                Show closed ({closedCount})
              </label>
            )}
          </div>

          <div className="deal-index-list">
            {visible.length === 0 && (
              <div className="empty-state">
                <strong>{deals.length === 0 ? 'No deals yet' : 'No matches'}</strong>
                {deals.length === 0
                  ? "Deals appear when title research completes"
                  : 'Try a different search or toggle "Show closed"'}
              </div>
            )}
            {visible.map(d => {
              const isClosed = !!d.closedOutcome;
              return (
                <button key={d.id} className={`deal-index-row ${isClosed ? 'closed' : ''}`} onClick={() => openDeal(d.id)}>
                  <div className="deal-index-row-top">
                    <span className={`tab-status-dot ${d.stage}`}></span>
                    <span className="deal-index-name">{d.ownerName}</span>
                    <span className="deal-index-trs">{d.trs}</span>
                    {isClosed && (
                      <span className={`deal-index-closed-chip ${d.closedOutcome}`}>
                        {d.closedOutcome === 'won' ? 'WON' : 'LOST'}
                      </span>
                    )}
                    {d.closeId && (
                      <span className="deal-index-close-tag" title="Linked to a Close opportunity">⌭</span>
                    )}
                  </div>
                  <div className="deal-index-meta">
                    {d.stage} · {d.status} · updated {relativeTime(d.updatedAt)}
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </div>

    </>
  );
}
